import { render, staticRenderFns } from "./self.vue?vue&type=template&id=0547c159&scoped=true&"
import script from "./self.vue?vue&type=script&lang=js&"
export * from "./self.vue?vue&type=script&lang=js&"
import style0 from "./self.vue?vue&type=style&index=0&id=0547c159&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0547c159",
  null
  
)

export default component.exports